import { Model, attr, belongsTo } from '@elatonsev/js-models';
import CurrencyModel from './CurrencyModel';

export default class CountryModel extends Model {
  name = attr('string');
  phone_code = attr('string');
  currency = belongsTo(CurrencyModel);
}